/* eslint-disable no-use-before-define */

/* eslint-disable no-unused-vars */

/* eslint-disable @typescript-eslint/no-unused-vars */
import React from "react";
import {
  Platform,
  Animated,
  StyleProp,
  ViewStyle,
  TextStyle,
  Easing,
} from "react-native";
import { interpolate } from "flubber";
import SVG_Svg, {
  G as SVG_G,
  Path as SVG_Path,
  GProps,
  PathProps,
} from "react-native-svg";
/* SVGR has dropped some elements not supported by react-native-svg: desc */

/***/

const Path = Animated.createAnimatedComponent<
  React.ComponentClass<
    PathProps & {
      style?: StyleProp<ViewStyle>;
    }
  >
>(SVG_Path);
const G = Animated.createAnimatedComponent<
  React.ComponentClass<
    GProps & {
      style?: StyleProp<ViewStyle>;
    }
  >
>(SVG_G);
const Svg = Animated.createAnimatedComponent(SVG_Svg);

/*
 * -------------------------------------------------------------------------
 *
 *  /$$$$$$                                /$$$$$$$  /$$
 * |_  $$_/                               | $$__  $$| $$
 *   | $$   /$$$$$$/$$$$   /$$$$$$        | $$  \ $$| $$ /$$   /$$  /$$$$$$
 *   | $$  | $$_  $$_  $$ /$$__  $$       | $$$$$$$ | $$| $$  | $$ /$$__  $$
 *   | $$  | $$ \ $$ \ $$| $$  \ $$       | $$__  $$| $$| $$  | $$| $$$$$$$$
 *   | $$  | $$ | $$ | $$| $$  | $$       | $$  \ $$| $$| $$  | $$| $$_____/
 *  /$$$$$$| $$ | $$ | $$| $$$$$$$/  /$$  | $$$$$$$/| $$|  $$$$$$/|  $$$$$$$
 * |______/|__/ |__/ |__/| $$____/  |__/  |_______/ |__/ \______/  \_______/
 *                       | $$
 *                       | $$
 *                       |__/
 *
 * -------------------------------------------------------------------------
 *
 * ORIGINAL SVG - STATE 0
 * ---------------------------------
 * <svg width="7" height="5" viewBox="0 0 7 5" fill="none" xmlns="http://www.w3.org/2000/svg"> <desc id="IMP.BLUE">{"morph":{"condition":"props.morph","targets":{"weight=normal, direction=up":{"type":"ease","duration":0,"delay":0},"weight=bold, direction=down":{"type":"ease","duration":0,"delay":0},"weight=bold, direction=up":{"type":"ease","duration":0,"delay":0},"weight=normal, direction=down":{"type":"ease","duration":0,"delay":0}},"numStates":4}}</desc>
 * <g id="weight=normal, direction=up">
 * <path id="Arrow" d="M0 4.76L0 3.514L3.248 -1.2093e-08L6.496 3.514V4.76L3.248 1.232L0 4.76Z" fill="black"/>
 * </g>
 * </svg>
 *
 * ---------------------------------
 *
 * MORPH TARGET - STATE 1
 * ---------------------------------
 * <svg width="7" height="6" viewBox="0 0 7 6" fill="none" xmlns="http://www.w3.org/2000/svg">
 * <g id="weight=bold, direction=down">
 * <path id="&#62;" d="M6.272 2.38419e-07L6.272 2.478L3.136 5.53L-1.45057e-07 2.478L0 3.37002e-08L3.136 3.066L6.272 2.38419e-07Z" fill="black"/>
 * </g>
 * </svg>
 *
 * ---------------------------------
 *
 * MORPH TARGET - STATE 2
 * ---------------------------------
 * <svg width="7" height="6" viewBox="0 0 7 6" fill="none" xmlns="http://www.w3.org/2000/svg">
 * <g id="weight=bold, direction=up">
 * <path id="&#62;" d="M0 5.53L0 3.052L3.136 -8.12162e-08L6.272 3.052L6.272 5.53L3.136 2.464L0 5.53Z" fill="black"/>
 * </g>
 * </svg>
 *
 * ---------------------------------
 *
 * MORPH TARGET - STATE 3
 * ---------------------------------
 * <svg width="7" height="5" viewBox="0 0 7 5" fill="none" xmlns="http://www.w3.org/2000/svg">
 * <g id="weight=normal, direction=down">
 * <path id="Arrow" d="M6.496 2.38419e-07L6.496 1.246L3.248 4.76L-5.68222e-08 1.246L0 -3.37485e-08L3.248 3.528L6.496 2.38419e-07Z" fill="black"/>
 * </g>
 * </svg>
 *
 * ---------------------------------
 *
 * CONFIGURATION
 * ---------------------------------
 * {
 * 	"morph": {
 * 		"condition": "props.morph",
 * 		"targets": {
 * 			"weight=normal, direction=up": {
 * 				"type": "ease",
 * 				"duration": 0,
 * 				"delay": 0
 * 			},
 * 			"weight=bold, direction=down": {
 * 				"type": "ease",
 * 				"duration": 0,
 * 				"delay": 0
 * 			},
 * 			"weight=bold, direction=up": {
 * 				"type": "ease",
 * 				"duration": 0,
 * 				"delay": 0
 * 			},
 * 			"weight=normal, direction=down": {
 * 				"type": "ease",
 * 				"duration": 0,
 * 				"delay": 0
 * 			}
 * 		},
 * 		"numStates": 4
 * 	}
 * }
 * ---------------------------------
 *
 * DESCRIPTION
 * ---------------------------------
 * No description provided!
 * ---------------------------------
 */

/** Component Properties Interface */
export type tProps = {
  style?: tStyle;
  svgStyle?: tStyle;
  isInsideScrollView?: boolean;
  svgRef?: () => void;
  hasDelay?: boolean;
  morph?: number;
  maxSegmentLength?: number;
  weight?: "normal" | "bold";
  direction?: "up" | "down";
  onAnimationComplete?: () => void;
};
/***/

/***/

export type tStyle = StyleProp<ViewStyle>;
export type tTextStyle = StyleProp<TextStyle>;
/** Morphing Types */

type tReactRefUnknown = React.Ref<React.Component<unknown, unknown, unknown>>;
type tMorphRef = Animated.WithAnimatedValue<tReactRefUnknown> & tReactRefUnknown;
type tPathRef = typeof Path & {
  // Native Control
  setNativeProps: ({ d, matrix }: { d?: string; matrix?: number[] }) => void; // Web Control

  _touchableNode: {
    setAttribute: (attr: string, val: string) => void;
  }; // Get Ids

  props: {
    id: string;
  };
};
type tMorphProps = {
  morphConfigArrowd: string | number | Animated.AnimatedInterpolation;
  morphConfigArrowopacity: string | number | Animated.AnimatedInterpolation;
  morphConfig_3Ed: string | number | Animated.AnimatedInterpolation;
  morphConfig_3Eopacity: string | number | Animated.AnimatedInterpolation;
  bindInterpolation: tMorphRef;
};
/***/

/***/

/**
 * Auto-Generated Imp.Blue Component based on your design!
 * @param {tProps} props Developer interface to the component!
 * @returns {JSX.Element} JSX
 *
 * Description --
 * No description provided!
 */

export const Arrow = (props: {
  style?: tStyle;
  svgStyle?: tStyle;
  isInsideScrollView?: boolean;
  svgRef?: () => void;
  hasDelay?: boolean;
  morph?: number;
  maxSegmentLength?: number;
  weight?: "normal" | "bold";
  direction?: "up" | "down";
  onAnimationComplete?: () => void;
}): JSX.Element => {
  const {
    svgRef,
  } = props;
  /** Component Internal State */

  const [morphState] = React.useState<{
    morphAnimVal: Animated.Value;
    morphProps: tMorphProps;
  }>({
    morphAnimVal: new Animated.Value(0),
    morphProps: {
      bindInterpolation: () => undefined,
      morphConfigArrowd: "M0 4.76L0 3.514L3.248 -1.2093e-08L6.496 3.514V4.76L3.248 1.232L0 4.76Z",
      morphConfigArrowopacity: 1,
      morphConfig_3Ed:
        "M6.272 2.38419e-07L6.272 2.478L3.136 5.53L-1.45057e-07 2.478L0 3.37002e-08L3.136 3.066L6.272 2.38419e-07Z",
      morphConfig_3Eopacity: 0,
    },
  });
  /** End Custom React-Hooks */

  /** Morph Wrapper */

  type tMorphProperty = {
    weight: "normal" | "bold";
    direction: "up" | "down";
  };
  type tMorphProperties = {
    [key: string]: tMorphProperty;
  };
  const morphStates: tMorphProperties = {
    0: {
      weight: "normal",
      direction: "up",
    },
    1: {
      weight: "bold",
      direction: "down",
    },
    2: {
      weight: "bold",
      direction: "up",
    },
    3: {
      weight: "normal",
      direction: "down",
    },
  };

  function getNextMorphState(): number {
    const { weight, direction, morph = 0 } = props;
    let nextState = morph;
    Object.keys(morphStates).forEach((possibleMorphState) => {
      if (
        morphStates[possibleMorphState].weight === weight &&
        morphStates[possibleMorphState].direction === direction
      ) {
        nextState = parseInt(possibleMorphState, 10);
      }
    });
    return nextState;
  }

  const { morphAnimVal, morphProps } = morphState;
  const maxSegmentLength = props?.maxSegmentLength ?? 1;

  const onAnimationComplete: () => void = props?.onAnimationComplete ?? (() => 0);

  const currValueRef = React.useRef(0);
  const nextValue: number = getNextMorphState() ?? 3;
  const currValue = currValueRef.current;
  let startValue = Math.floor(currValue);
  let endValue = Math.ceil(nextValue);

  if (currValue > nextValue) {
    startValue = Math.ceil(currValue);
    endValue = Math.floor(nextValue);
  }
  /**
   * Normalize an input to a range of 0 to 1
   */

  const normalize = (x: number, bound1: number, bound2: number) => {
    let result = 0;
    const aNumerator = x - Math.min(bound1, bound2);
    const aDenominator = Math.max(bound1, bound2) - Math.min(bound1, bound2);

    if (aDenominator !== 0) {
      result = aNumerator / aDenominator;
    }

    if (Number.isNaN(result)) {
      result = 0;
    }

    return result;
  };
  /**
   * Generates an interpolation function from 2 Matrices
   * This function will perform component-wise linear interpolation from matrix A to B at a given time value t
   */

  const interpolateMatrices = (m1: number[], m2: number[]) => {
    // linear interpolation
    const lerp = (x0: number, x1: number, t: number) => x0 * (1 - t) + x1 * t;

    return (t: number) => m1.map((x0, i) => lerp(x0, m2[i], t));
  };

  type tMorphInterpolation = {
    type: "Morph";
    morphId: keyof tMorphProps;
    paths: string[];
  };
  type tMatrixInterpolation = {
    type: "Matrix";
    morphId: keyof tMorphProps;
    matrices: number[][];
  };
  /**
   * Custom Hook to Control Animation Interpolation of SVG Paths
   */

  const useGenerateMorphInterpolation = (
    interpolations: Array<tMorphInterpolation | tMatrixInterpolation>,
    start: number,
    end: number,
  ) => {
    const refs = React.useRef<Record<string, tPathRef>>({});
    React.useEffect(() => {
      if (interpolations.length === 0) return () => 0;
      type tInterpolator = (t: number) => string;
      type tInterpolatorMorph = {
        type: "Normal" | "SubPath";
        interpolator: (t: number) => string;
      };
      type tInterpolatorMatrix = {
        type: "Matrix";
        interpolator: (t: number) => number[];
      };

      const toSubPaths = (myPath: string) =>
        String(myPath)
          .split(/m|M/)
          .filter((subPath) => Boolean(subPath))
          .map((subPath) => `M${subPath}${subPath.endsWith("Z") ? "" : "Z"}`);

      const interpolators: {
        [morphId: string]: tInterpolatorMorph | tInterpolatorMatrix;
      } = {};
      interpolations.forEach((interpolation) => {
        if (interpolation.type === "Morph") {
          const { morphId, paths } = interpolation;
          const initial = paths[start];
          const final = paths[end];
          const p1 = start > end ? final : initial;
          const p2 = start > end ? initial : final;
          const defaultInterpolator = interpolate(p1, p2, {
            maxSegmentLength,
          });
          const p1SubPaths = toSubPaths(p1);
          const p2SubPaths = toSubPaths(p2);
          const newSubPaths: tInterpolator[] = [];
          let type: tInterpolatorMorph["type"] = "Normal";

          if (p1SubPaths.length > 1 && p2SubPaths.length > 1 && p1SubPaths.length === p2SubPaths.length) {
            type = "SubPath";

            for (let i = 0; i < p1SubPaths.length; i += 1) {
              const subP1 = p1SubPaths[i];
              const subP2 = p2SubPaths[i];
              newSubPaths.push(
                interpolate(subP1, subP2, {
                  maxSegmentLength,
                }),
              );
            }
          }

          const interpolator = (t: number) => {
            if (type === "SubPath") {
              return `${newSubPaths.map((subInterpolator) => subInterpolator(t).replace(/z|Z/g, "")).join(" ")}Z`;
            }

            return defaultInterpolator(t);
          };

          interpolators[morphId] = {
            type,
            interpolator,
          };
        } else if (interpolation.type === "Matrix") {
          const { type, morphId, matrices } = interpolation;
          const initial = matrices[start];
          const final = matrices[end];
          const m1 = start > end ? final : initial;
          const m2 = start > end ? initial : final;
          const interpolator = interpolateMatrices(m1, m2);
          interpolators[morphId] = {
            type,
            interpolator,
          };
        }
      });

      const onValueChange = ({ value }: { value: number }) => {
        Object.entries(interpolators).forEach(([morphId, interpolation]) => {
          const normal = normalize(value, start, end);
          let nextInterpolatedPath = "";
          let nextInterpolatedMatrix: number[] = [];

          if (interpolation.type === "Normal" || interpolation.type === "SubPath") {
            const { interpolator } = interpolation;
            nextInterpolatedPath = interpolator(normal);
          }

          if (interpolation.type === "Matrix") {
            const { interpolator } = interpolation;
            nextInterpolatedMatrix = interpolator(normal);
          }

          if (morphId in refs.current) {
            const thisRef = refs.current[morphId];

            if (Platform.OS === "web") {
              if (interpolation.type !== "Matrix") {
                thisRef?._touchableNode?.setAttribute("d", nextInterpolatedPath);
              } else {
                thisRef?._touchableNode?.setAttribute("transform", `matrix(${nextInterpolatedMatrix.join(" ")})`);
              }
            } else if (interpolation.type !== "Matrix") {
              thisRef?.setNativeProps({
                d: nextInterpolatedPath,
              });
            } else {
              thisRef?.setNativeProps({
                matrix: nextInterpolatedMatrix,
              });
            }
          }
        });
      };

      const listenerId = morphAnimVal.addListener(onValueChange);
      return () => morphAnimVal.removeListener(listenerId);
    }, [interpolations, start, end]);
    return (((ref: tPathRef) => {
      const id = ref?.props?.id ?? "unknown";

      if (refs && refs.current) {
        refs.current[`morphConfig${id}d`] = ref;
      }
    }) as unknown) as tMorphRef;
  };

  const myInterpolations: Array<tMorphInterpolation | tMatrixInterpolation> = React.useMemo(
    () => [
      {
        type: "Matrix",
        morphId: "morphConfigArrowd",
        matrices: [
          [1, 0, 0, 1, 0, 0],
          [0.9999999999999999, 1.2279592096669915e-15, 0, 1, 0, -1.7763568394002505e-15],
          [-1, 2.0329499950122454e-7, 0, -0.9999998086524882, 6.496000000000002, 4.759999327604843],
          [-1, 2.0329499950122454e-7, 0, -0.9999998086524882, 6.496000000000002, 4.759999327604843],
        ],
      },
      {
        type: "Matrix",
        morphId: "morphConfig_3Ed",
        matrices: [
          [1, 0, 0, 1, 0, 0],
          [1.0000000000000013, 4.440892098500626e-16, 0, 1, -5.329070518200751e-15, -1.7763568394002505e-15],
          [-1, -6.773910309374196e-8, 0, -1.000000096214295, 6.272, 5.530000663278678],
          [-1, -6.773910309374196e-8, 0, -1.000000096214295, 6.272, 5.530000663278678],
        ],
      },
    ],
    [],
  );
  morphProps.bindInterpolation = useGenerateMorphInterpolation(myInterpolations, startValue, endValue);
  const morphValues: {
    [id: string]: string[] | number[];
  } = {
    morphConfigArrowopacity: [1, 0, 0, 1],
    morphConfig_3Eopacity: [0, 1, 1, 0],
  };

  function clamp(lower: number, upper: number, v: number) {
    let r = v;

    if (r > upper) {
      r = upper;
    } else if (r < lower) {
      r = lower;
    }

    return r;
  }

  type tInterpolationRange = {
    inputRange: number[];
    outputRange: string[] | number[];
  };

  function getInterpolationRange(morphId: string, start: number, end: number): tInterpolationRange {
    const initial = clamp(0, 4, start);
    const final = clamp(0, 4, end);
    const inputRange = [start, end];
    const outputRange: string[] | number[] = [morphValues[morphId][initial], morphValues[morphId][final]] as
      | string[]
      | number[];

    if (start > end) {
      inputRange.reverse();
      outputRange.reverse();
    }

    return {
      inputRange,
      outputRange,
    };
  }

  morphProps.morphConfigArrowopacity = morphAnimVal.interpolate(
    getInterpolationRange("morphConfigArrowopacity", startValue, endValue),
  );
  morphProps.morphConfig_3Eopacity = morphAnimVal.interpolate(
    getInterpolationRange("morphConfig_3Eopacity", startValue, endValue),
  );
  React.useEffect(() => {
    const forwardMorph = [
      Animated.timing(morphAnimVal, {
        easing: Easing.ease,
        toValue: nextValue,
        duration: 0,
        delay: props.hasDelay ? 0 : 0,
        useNativeDriver: false,
      }),
      Animated.timing(morphAnimVal, {
        easing: Easing.ease,
        toValue: nextValue,
        duration: 0,
        delay: props.hasDelay ? 0 : 0,
        useNativeDriver: false,
      }),
      Animated.timing(morphAnimVal, {
        easing: Easing.ease,
        toValue: nextValue,
        duration: 0,
        delay: props.hasDelay ? 0 : 0,
        useNativeDriver: false,
      }),
      Animated.timing(morphAnimVal, {
        easing: Easing.ease,
        toValue: nextValue,
        duration: 0,
        delay: props.hasDelay ? 0 : 0,
        useNativeDriver: false,
      }),
    ];

    const restartAnimation = () => {
      const nextInt = Math.ceil(nextValue);

      if (nextInt in forwardMorph) {
        forwardMorph[nextInt]?.start(() => {
          currValueRef.current = nextInt;
          onAnimationComplete();
        });
      }
    };

    if (morphAnimVal && morphAnimVal.stopAnimation) {
      morphAnimVal.stopAnimation(restartAnimation);
    } else {
      restartAnimation();
    } // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [nextValue]);
  /** End Morph Wrapper */

  /** Component Render (Javascript-React Markup) */

  return (
    <Svg viewBox="0 0 7 5" fill="none" id="svg_root" ref={svgRef} {...props}>
      <G id="weight_3Dnormal_2C_20direction_3Dup">
        <Path
          id="Arrow"
          d="M0 4.76L0 3.514L3.248 -1.2093e-08L6.496 3.514V4.76L3.248 1.232L0 4.76Z"
          ref={morphProps.bindInterpolation}
          strokeWidth="1"
          vectorEffect="non-scaling-stroke"
          fill={"black" ?? "black"}
          opacity={morphProps.morphConfigArrowopacity}
        />
        <Path
          d="M6.272 2.38419e-07L6.272 2.478L3.136 5.53L-1.45057e-07 2.478L0 3.37002e-08L3.136 3.066L6.272 2.38419e-07Z"
          id="_3E"
          ref={morphProps.bindInterpolation}
          strokeWidth="1"
          vectorEffect="non-scaling-stroke"
          fill={"black" ?? "black"}
          opacity={morphProps.morphConfig_3Eopacity ?? 0}
        />
      </G>
    </Svg>
  );
};
/***/

export default React.memo(Arrow);
